export default "__VITE_ASSET__JewN5Hbc__"